import React from "react"
import MainContainer from "../containers/MainContainer"
import HeadData from "../data/HeadData"
import PageHeaderImageBg from '../headers/PageHeaderImageBg'
import PageHeaderText from "../headers/PageHeaderText"
import HeaderNav from "../navigation/HeaderNav"
import PageRequestServiceSection from "../sections/PageRequestServiceSection"

export default () => (
  <MainContainer>
    <HeadData 
      title='Request Service' 
      description='If you are a client and you need to request service, please call us at (714) 891-8804 or email us using the form.' 
    />

    <PageHeaderImageBg>
      <HeaderNav />
      <PageHeaderText
        title='Request Service'
      />
    </PageHeaderImageBg>

    <PageRequestServiceSection />
  </MainContainer>
)
